module.exports = __webpack_public_path__ + "static/media/rsvpCardImg.26abc39c.png";